module.exports = __webpack_public_path__ + "img/87.571c3986.jpg";